import FluxUtils from 'flux/utils';

import AuthenticationActions from 'sharedreact/actions/AuthenticationActions';
import SessionWarningDialog from 'sharedreact/components/SessionWarningDialog';
import SessionWarningMode from 'sharedreact/constants/SessionWarningMode';
import AuthenticationStore from 'sharedreact/stores/AuthenticationStore';
import SettingsStore from 'sharedreact/stores/SettingsStore';
import asFunctional from 'sharedreact/components/asFunctional';

type State = ConstructorParameters<typeof SessionWarningDialog>[0];

function getStores () {
  return [
    AuthenticationStore,
    SettingsStore
  ];
}

function calculateState (prevState?: State): State {
  const mode: number = AuthenticationStore.getState().sessionWarningMode;

  return {
    language: SettingsStore.getLanguage(),
    mode: mode,
    onExtendSession: AuthenticationActions.extendSession,
    onClose: () => {
      if (mode === SessionWarningMode.Expired) {
        AuthenticationActions.handleClosedSession();
      }
      AuthenticationActions.clearWarningMode();
    }
  };
}

export default FluxUtils.Container.createFunctional(
  asFunctional(SessionWarningDialog),
  getStores,
  calculateState
);